import React from "react";
import PlusMinus from './components/plusMinus';
import FormikCustomInput from '../formikCustomInput';

export interface IFormikPlusMinusInputProps {
  name: string;
  label: string | any;
  form?: any;
  field?: any;
  min: number;
  max: number;
}


const FormikPlusMinusInput = ({min, max, form, field, ...props}: IFormikPlusMinusInputProps) => (
  <FormikCustomInput
    {...props}
    inputComponent={<PlusMinus
      min={min}
      max={max}
      setCount={(count) => form.setFieldValue(field.name, count)}
    />}
  />
);

FormikPlusMinusInput.defaultProps = {
  name: "",
  label: "",
  currency: null,
  min: 1,
  max: 100
};

export default FormikPlusMinusInput;
